import axios from 'axios';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  async getSalesOrder(id) {
    return axios
      .get(`${BASE_API}/bridge/${id}`)
      .then(response => response)
      .catch((error) => {
        console.error('err', error);
        return { exists: false }
      });
  },
  async importOrder(num, issue) {
    return axios({
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/bridge/${num}/import`,
      data: { issue },
    })
  },
  async cancelImport(num) {
    return axios({
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/bridge/${num}/cancel-import`,
    })
  },
  async cancelOrder(num, params) {
    return axios({
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/bridge/${num}/cancel`,
      data: params
    })
  },
};



// WEBPACK FOOTER //
// /src/services/bridge.js